import { render, staticRenderFns } from "./GraphicalReport.vue?vue&type=template&id=4d51080b&scoped=true&"
import script from "./GraphicalReport.vue?vue&type=script&lang=js&"
export * from "./GraphicalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51080b",
  null
  
)

export default component.exports